import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/note_popup.css";
import LoadingPopup from "../helpers/loading_component.js";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const MaterialBox = (props) => {
  const [headings, setHeadings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [content, setContent] = useState(props.material.content);
  const [files, setFiles] = useState([]);

  const makeid = (length) => {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  const getHeadings = () => {
    document
      .getElementById("mainContent")
      .querySelectorAll("h2, h3, h4, h5, h6, p")
      .forEach(function (el) {
        el.id = makeid(5);
      });

    const elements = Array.from(
      document
        .getElementById("mainContent")
        .querySelectorAll("h2, h3, h4, h5, h6")
    ).map((element) => ({
      id: element.id,
      text: element.textContent ?? "",
      level: Number(element.tagName.substring(1)),
    }));
    setHeadings(elements);

    setLoading(false);
  };

  const fetchFiles = async () => {
    var body = {
      materialId: props.material.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getMaterialFilesMaterialId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFiles(data);
      })
      .catch((error) => {});
  };

  const download = async (url, filename) => {
    const data = await fetch(url);
    const blob = await data.blob();
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.setAttribute("href", objectUrl);
    link.setAttribute("download", filename);
    link.style.display = "none";

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  const downloadFile = (e) => {
    var file = files.filter((el) => el.id === +e.target.value)[0];
    download(file.link, file.name);
  };

  const documentsView = (
    <>
      <div style={{ marginTop: "3vh" }}></div>

      {files.length > 0 ? (
        <>
          <p>PLIKI W MATERIALE</p>
          <table
            style={{ width: "80%" }}
            id="detailClientTable"
            className="clients_table"
          >
            <tr>
              <th>Plik</th>
              <th></th>
            </tr>
            {files.length > 0
              ? files.map((el, index) => (
                  <>
                    <tr>
                      <td
                        style={{
                          textAlign: "left",
                          width: "40%",
                          padding: "5px 20px",
                          height: "3vh",
                          wordWrap: "anywhere",
                        }}
                      >
                        {el.name}
                      </td>
                      <td
                        style={{
                          textAlign: "left",
                          width: "10%",
                          padding: "5px 20px",
                          height: "3vh",
                        }}
                      >
                        <button
                          className="refreshButton"
                          value={el.id}
                          onClick={downloadFile}
                        >
                          pokaż
                        </button>
                      </td>
                    </tr>
                  </>
                ))
              : ""}
          </table>
        </>
      ) : (
        ""
      )}
    </>
  );

  const toc = (
    <>
      {headings.length > 0 ? (
        <>
          <p style={{ fontWeight: "600" }}>SPIS TREŚCI</p>
          <nav>
            <ul style={{ paddingInlineStart: "6vw" }}>
              {headings.map((heading) => (
                <>
                  <li
                    key={heading.id}
                    style={{ marginLeft: `${heading.level - 2}em` }}
                  >
                    <a href={`#${heading.id}`} rel="noopener">
                      {heading.text}
                    </a>
                  </li>
                </>
              ))}
            </ul>
          </nav>
        </>
      ) : (
        ""
      )}
    </>
  );

  const toc2 = (
    <>
      {searchResult.length > 0 ? (
        <>
          <p style={{ margin: "0" }}>WYNIKI WYSZUKIWANIA</p>
          <nav>
            <ul style={{ columns: "5" }}>
              {searchResult.map((heading) => (
                <>
                  <li key={heading.id}>
                    <a href={`#${heading.id}`} rel="noopener">
                      {heading.text.substring(0, 15) + "..."}
                    </a>
                  </li>
                </>
              ))}
            </ul>
          </nav>
        </>
      ) : (
        ""
      )}
    </>
  );

  useEffect(() => {
    setLoading(true);
    getHeadings();
    fetchFiles();
  }, []);

  const clearSearch = () => {
    setLoading(true);
    var inputText = document.getElementById("mainContent");
    var innerHTML = inputText.innerHTML;

    var targets = inputText.querySelectorAll("mark");
    for (let target of targets) {
      target.outerHTML = target.innerHTML;
    }
    setSearchResult([]);
    setSearch("");
    setLoading(false);
  };

  const clearSearch2 = () => {
    if (!search) {
      return;
    }
    setLoading(true);
    var inputText = document.getElementById("mainContent");
    var innerHTML = inputText.innerHTML;

    var targets = inputText.querySelectorAll("mark");
    for (let target of targets) {
      target.outerHTML = target.innerHTML;
    }
    setSearchResult([]);
    setLoading(false);
  };

  const scrollBox = (e) => {
    if (!search) {
      return;
    }
    clearSearch2();
    var inputText = document.getElementById("mainContent");
    var innerHTML = inputText.innerHTML;

    var targets = inputText.querySelectorAll("mark");
    for (let target of targets) {
      target.outerHTML = target.innerHTML;
    }

    var innn = innerHTML.replaceAll(
      search.toLowerCase(),
      "<mark class='highlight1'>" + search.toLowerCase() + "</mark>"
    );

    inputText.innerHTML = innn;

    var text = document.getElementById("mainContent");
    var asd = Array.from(text.querySelectorAll("p"))
      .filter((ex) =>
        ex.textContent.toLowerCase().includes(search.toLowerCase())
      )
      .map((element) => ({
        id: element.id,
        text: element.textContent ?? "",
      }));
    setSearchResult(asd);
  };

  return (
    <>
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="mainContainerMaterialPopUp">
            <div className="closeButtonBoxNotePopUp">
              <div className="closeButtonBoxNotePopUp_col1">
                {props.material.name}
              </div>
              <div style={{ width: "100%" }} className="closeBox">
                <button
                  className="closeClientButton"
                  onClick={props.closePopUp}
                >
                  X
                </button>
              </div>
            </div>
            <div
              style={{
                marginTop: "3vh",
                marginBottom: "5vh",
                width: "40%",
                display: "flex",
                gap: "10px",
                alignItems: "center",
              }}
            >
              <input
                type="text"
                id="signature"
                name="signature"
                style={{ height: "3vh", margin: "0" }}
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
              <button
                className="closeClientButton"
                style={{
                  height: "3vh",
                  borderRadius: "30px",
                  backgroundColor: "lightgray",
                  color: "black",
                  textDecoration: "none",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={scrollBox}
              >
                WYSZUKAJ
              </button>
              <button
                className="closeClientButton"
                style={{
                  height: "3vh",
                  borderRadius: "30px",
                  backgroundColor: "lightgray",
                  color: "black",
                  textDecoration: "none",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={clearSearch}
              >
                WYCZYŚĆ
              </button>
            </div>
            <div style={{ fontSize: "1vw" }}>{toc2}</div>
            <div>{toc}</div>
            <div
              className="contentBoxNotePopUp"
              id="mainContent"
              style={{
                height: "100%",
                fontSize: "1vw",
                padding: "2vw 8vw",
                border: "1px solid black",
              }}
              dangerouslySetInnerHTML={{ __html: content }}
            ></div>
            {documentsView}
          </div>
        </>
      )}
    </>
  );
};

export default MaterialBox;
